var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"custom-loading"},[_c('div',{staticClass:"custom-loading-Mask"}),_c('div',{staticClass:"custom-loading-box"},[_c('div',{staticClass:"custom-loading-content"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('em',{style:({borderLeftColor:_vm.progressColor})})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }